import { render, staticRenderFns } from "./Cancel.vue?vue&type=template&id=72b91cae&scoped=true&lang=html&"
import script from "./Cancel.vue?vue&type=script&lang=js&"
export * from "./Cancel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b91cae",
  null
  
)

export default component.exports